module.exports = __webpack_public_path__ + "img/fecha-22-sep-2024.7d703aff.png";